// fieldset の UA スタイル（border・padding・margin）をリセット
.chipGroup {
  border: none;
  padding: 0;
  margin: 0;
}
